import FileCopyOutlined from '@material-ui/icons/FileCopyOutlined'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {Trans} from 'react-i18next'
import messages from '../../../../assets/messages'
import {config} from '../../../../config'
import {PammOfferType} from '../../../../graphql/types'
import {KpiToggleButton} from './KpiToggleButton'
import {ActionButton, Actions} from './OfferCardActions.styled'

type OfferCardActionsProps = {
  offer: PammOfferType
}

/**
 * Actions for an offer card: Copy Link (copies the offer's join link
 * `?pammManager=&pammOffer=`) and the KPIs toggle (PT-5710).
 *
 * @param offer - The PAMM offer these actions operate on.
 */
export const OfferCardActions = ({offer}: OfferCardActionsProps) => {
  const joinLink = `${config.frontendUrl}?pammManager=${offer.skygroundAccountId}&pammOffer=${offer.id}`

  return (
    <Actions>
      <KpiToggleButton offer={offer} />
      <CopyToClipboard text={joinLink}>
        <ActionButton variant="outlined" size="small" startIcon={<FileCopyOutlined />}>
          <Trans {...messages.copyLink} />
        </ActionButton>
      </CopyToClipboard>
    </Actions>
  )
}
